"use client";

import { BuilderBlockProps } from "@/types";
import {
  FC,
  PropsWithChildren,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import cn from "classnames";
import { ComparisonChartContext } from "../ComparisonChartTable/ComparisonChartTable";
import styles from "../ComparisonChartTable/ComparisonChartTable.module.css";

export type TableCellProps = {
  headerType?: "colHeader" | "rowHeader";
  colspan?: number;
  rowspan?: number;
} & Partial<BuilderBlockProps>;

const TableCell: FC<PropsWithChildren<TableCellProps>> = ({
  children,
  headerType,
  colspan = 1,
  rowspan = 1,
  attributes,
}) => {
  const { highlightColumnIndex } = useContext(ComparisonChartContext);
  const cellRef = useRef<HTMLTableCellElement>(null);
  const [isHighlighted, setIsHighlighted] = useState(false);

  const isHeader = !!headerType;
  const Element = isHeader ? "th" : "td";

  useEffect(() => {
    if (highlightColumnIndex !== undefined && cellRef.current) {
      setIsHighlighted(highlightColumnIndex === cellRef.current.cellIndex);
    } else {
      setIsHighlighted(false);
    }
  }, [highlightColumnIndex]);

  return (
    <Element
      ref={cellRef}
      {...attributes}
      {...(isHeader
        ? { scope: headerType === "colHeader" ? "col" : "row" }
        : undefined)}
      colSpan={colspan}
      rowSpan={rowspan}
      className={cn(attributes?.className, isHighlighted && styles.highlight)}
    >
      {children}
    </Element>
  );
};

export default TableCell;
